import { render } from "./service_config_add_modal.vue?vue&type=template&id=02424227"
import script from "./service_config_add_modal.vue?vue&type=script&lang=js"
export * from "./service_config_add_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__